import { useContext } from 'react'
import ApproverContext from 'app/contexts/ApproverContext'
const useApprover = () => useContext(ApproverContext)

export default useApprover
